import LanguagePicker from "../i18n/LanguagePicker";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import "@/roleapps/roleapps.css";

export const money = (n) => "€" + Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export default function RoleShell({ mark, title, subtitle, children, testid }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const b = user?.branding_context || {};
  return (
    <div className="ra-shell" data-testid={testid}>
      <header className="ra-top">
        <div className="ra-top-l">
          <div className="ra-mark">{mark}</div>
          <div>
            <div className="ra-title">{title}</div>
            <div className="ra-sub">{subtitle || b.company_name || "LHC Platform"}</div>
          </div>
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
            <LanguagePicker compact />
          </div>
        </div>
        <div className="ra-top-r">
          <div className="ra-user"><b>{user?.name}</b>{user?.email} · {user?.role}</div>
          <button className="ra-signout" data-testid="role-signout" onClick={() => logout().finally(() => nav("/login"))}>Sign out</button>
        </div>
      </header>
      <main className="ra-main">{children}</main>
    </div>
  );
}
